module.exports = __webpack_public_path__ + "static/media/iiitb-01.7259fccf.png";